import { createAction, props } from '@ngrx/store';

export const setId = createAction(
    '[Assessment Component] Set Id',
    props<{ assessmentDetailId: number }>(),
);
export const resetId = createAction('[Assessment Component] Reset Id');
